import React, { useEffect, useMemo, useState } from "react";
import Dist from "../../images/overlay.png";
import hoverEffect from "hover-effect";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";
// import { Link } from "react-router-dom";
import { useRoomContext } from "../../context/RoomContext";
import imageUrl from "../../images/selected/family_suite_quad.webp";
import imageUrl1 from "../../images/selected/family_suite_quad1.webp";
import imageUrl2 from "../../images/selected/premium_triple.webp";
import imageUrl3 from "../../images/selected/premium_triple1.webp";
import imageUrl4 from "../../images/selected/premium_king.webp";
import imageUrl5 from "../../images/selected/premium_king1.webp";
import imageUrl6 from "../../images/selected/premium_twin.webp";
import imageUrl7 from "../../images/selected/premium_twin1.webp";
import imageUrl8 from "../../images/selected/luxury_suite_king.webp";
import imageUrl9 from "../../images/selected/luxury_suite_king1.webp";

const Rooms = () => {
  const mobile = useMobile();
  const tab = useTab();
  const { roomData } = useRoomContext();
  const [hoveredRoomId, setHoveredRoomId] = useState(null);
  const [fetch, setFetch] = useState(false);

  const images = useMemo(
    () => [
      { mainImg: imageUrl4, secondaryImg: imageUrl5, price: 3500 },
      { mainImg: imageUrl6, secondaryImg: imageUrl7, price: 3500 },
      { mainImg: imageUrl2, secondaryImg: imageUrl3, price: 6000 },
      { mainImg: imageUrl, secondaryImg: imageUrl1, price: 8000 },
      { mainImg: imageUrl8, secondaryImg: imageUrl9, price: 3500 },
    ],
    []
  );

  useEffect(() => {
    if (fetch) {
      images.map(
        (room, index) =>
          new hoverEffect({
            parent: document.querySelector(`.img-section-${index}`),
            intensity: 0.1,
            image1: room.mainImg,
            image2: room.secondaryImg,
            displacementImage: Dist,
          })
      );
    }
  }, [fetch, images]);
  useEffect(() => {
    if (roomData.length > 0) {
      setFetch(true);
    }
  }, [roomData]);

  const handleMouseEnter = (id: any) => setHoveredRoomId(id);
  const handleMouseLeave = () => setHoveredRoomId(null);

  const roomTitleOrder = [
    "Premium King - 2 pax",
    "Premium Twin - 2 pax",
    "Premium Triple - 3 pax",
    "Family Suite Quadruple - 4 pax ",
    "Luxury Suite King - 2 pax",
  ];

  const sortedRoomData = [...roomData].sort((a, b) => {
    const titleA = a?.room_name ?? "";
    const titleB = b?.room_name ?? "";

    return roomTitleOrder.indexOf(titleA) - roomTitleOrder.indexOf(titleB);
  });

  return (
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-4288b31b elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="4288b31b"
        data-element_type="section"
        data-settings='{"stretch_section":"section-stretched","hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
      >
        <div className="elementor-container elementor-column-gap-default">
          <div className="elementor-row">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-5ffd294a"
              data-id="5ffd294a"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <div
                    className="elementor-element elementor-element-6db2fc5e elementor-widget elementor-widget-hoteller-distortion-grid"
                    data-id="6db2fc5e"
                    data-element_type="widget"
                    data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                    data-widget_type="hoteller-distortion-grid.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="distortion_grid_wrapper">
                        <div
                          className="distortion_grid_item distortion_grid_item--bg theme-3 custom-room-grid"
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)",
                            overflow: "hidden",
                          }}
                        >
                          {sortedRoomData.map((room, index) => (
                            <div
                              key={room.id}
                              className="distortion_grid_item-img"
                              data-displacement="upload/4.png"
                              data-intensity="0.2"
                              data-speedin="1.6"
                              data-speedout="1.6"
                              style={{
                                position: "relative",
                                gridColumn:
                                  roomData.length % 2 !== 0 &&
                                  index === roomData.length - 1 &&
                                  !mobile &&
                                  !tab
                                    ? "span 2"
                                    : "auto",
                              }}
                            >
                              <div
                                className="distortion_grid_item-content custom_distortion_grid_item-content1"
                                style={{
                                  position: "absolute",
                                  top: "15%",
                                  left: "60%",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: 2,
                                  width: "calc(100% - 85px)",
                                }}
                              >
                                <span className="distortion_grid_item-meta">
                                  {room?.attributes?.Room_Title}
                                </span>
                                <h2 className="distortion_grid_item-title">
                                  {room?.room_name}
                                </h2>
                              </div>
                              <div
                                key={room.id}
                                className={`img-section img-section-${index} custom-room-img`}
                                style={{
                                  width:
                                    roomData.length % 2 !== 0 &&
                                    index === roomData.length - 1 &&
                                    !mobile &&
                                    !tab
                                      ? "100dvw"
                                      : "50dvw",
                                  height: "100dvh",
                                  objectFit: "cover",
                                  position: "relative",
                                }}
                                onMouseEnter={() => handleMouseEnter(room.id)}
                                onMouseLeave={handleMouseLeave}
                              >
                                {(mobile ||
                                  tab ||
                                  hoveredRoomId === room.id) && (
                                  <div
                                    className="distortion_grid_item-subtitle custom-distortion_grid_item-subtitle"
                                    style={{
                                      position: "absolute",
                                      bottom: "15%",
                                      left:
                                        roomData.length % 2 !== 0 &&
                                        index === roomData.length - 1 &&
                                        !mobile &&
                                        !tab
                                          ? "18%"
                                          : "28%",
                                      transform: "translate(-50%, -50%)",
                                      zIndex: 2,
                                    }}
                                  >
                                    <a
                                      className="distortion_grid_item-link"
                                      href={`${window.location.origin}/booking?&be-room=${room?.room_id}`}
                                      // state={{
                                      //   id: room?.id,
                                      // }}
                                    >
                                      View Details
                                    </a>
                                  </div>
                                )}
                                <div className="custom-gradient"></div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Rooms;
